// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import FileFill from "@store/Library/Components/Icons/File/FileFill";
import { css } from "styled-components";

export interface DocumentsStyles {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    documentGridItem?: GridItemProps;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
}

export const documentsListStyles: DocumentsStyles = {
    wrapper: {
        css: css`
            > * {
                padding: 0;
            }
        `,
    },
    container: {
        gap: 20,
    },
    documentGridItem: {
        width: [12, 6, 4, 3, 3],
    },
    documentLink: {
        css: css`
            width: 100%;
            height: 100%;

            &:hover {
                text-decoration: none !important;

                * {
                    ${transitionHoverStyles()}
                    color: ${getColor("secondary")};
                }
            }
        `,
        typographyProps: {
            css: css`
                display: flex;
                align-items: center;
                width: 100%;
                padding-right: 0.5em;
            `,
        },
    },
    documentIcon: {
        src: FileFill,
        size: 40,
        color: "primary",
        css: css`
            margin-right: 1em;
        `,
    },
    documentNameText: {
        color: "primary",
        ellipsis: true,
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.base};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
};
